import { useMemo } from "react";

const range = (start, end) => {
  let length = end - start + 1;
  return Array.from({ length }, (_, idx) => idx + start);
};

export const DOTS = "...";

export const usePagination = ({
  totalCount,
  pageSize,
  siblingCount = 1,
  currentPage,
}) => {
  const paginationRange = useMemo(() => {
    const totalPageCount = Math.ceil(totalCount / pageSize);

    if (totalPageCount <= 3) {
      return range(1, totalPageCount);
    }

    return [1, 2, 3, DOTS, totalPageCount];
  }, [totalCount, pageSize]);

  return paginationRange;
};
